/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AutomatedSegmentIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Automated Segment',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m32.514 14.337.078 2.248a1.834 1.834 0 0 0 .939 1.533l1.963 1.1-2.248.078a1.834 1.834 0 0 0-1.533.939l-1.1 1.963-.079-2.248a1.83 1.83 0 0 0-.939-1.533l-1.961-1.095 2.248-.079a1.83 1.83 0 0 0 1.538-.943ZM6.8 1.044l.113 3.134a2.556 2.556 0 0 0 1.3 2.137l2.736 1.532-3.126.113a2.553 2.553 0 0 0-2.137 1.305L4.154 12l-.113-3.133A2.553 2.553 0 0 0 2.736 6.73L0 5.2l3.133-.114A2.552 2.552 0 0 0 5.27 3.78ZM26 9.565A1.565 1.565 0 0 0 24.435 8H14v1.129a1.48 1.48 0 0 1-1.366 1.562l-4.6.181a1.207 1.207 0 0 0-1.024.655L6 13.5v18.94A1.565 1.565 0 0 0 7.565 34h16.87A1.565 1.565 0 0 0 26 32.435ZM8 14h5.5v2H8Zm0 4h9v2H8Zm0 4h10.75v2H8Zm16 6H8v-2h16ZM28.274 0l.3 2.229a1.83 1.83 0 0 0 1.085 1.434l2.06.9-2.229.3a1.834 1.834 0 0 0-1.434 1.085L27.155 8l-.3-2.229a1.834 1.834 0 0 0-1.085-1.434l-2.059-.9 2.23-.3a1.83 1.83 0 0 0 1.436-1.077Z"
    />
  </svg>`;
};
